import React from 'react'

import routes from 'src/lib/rails-routes/rails-routes'
import { t } from 'src/lib/i18n-react'
import { LL_INTRODUCTION_VIDEO_URL, VIDEO_SIZE } from 'src/lib/media'
import { usePageParams } from 'src/utils/params'
import ActivityWrapupCardWithAction from 'src/pages/ActivityWrapup/subcomponents/ActivityWrapupCardWithAction/ActivityWrapupCardWithAction'
import MediaThumbnail from 'src/ui/MediaThumbnail/MediaThumbnail'
import MediaPlayableInModal from 'src/ui/MediaPlayableInModal/MediaPlayableInModal'

import lessonThumbnail from './assets/lesson.svg'

const WrapupCardLiveLesson = () => {
  const { l2Code } = usePageParams()

  return (
    <ActivityWrapupCardWithAction
      title={t('Schedule a Live Lesson')}
      description={t(
        "Now that you know some vocabulary, it's time to practice speaking for real!"
      )}
      action={{
        label: t('Schedule Now'),
        href: routes.advanced_schedule(l2Code),
      }}
      imageSection={
        <MediaPlayableInModal
          title={t('Live Lessons')}
          mediaUrl={LL_INTRODUCTION_VIDEO_URL}
          mediaSize={VIDEO_SIZE}
        >
          <MediaThumbnail
            altText={t('Live Lessons')}
            thumbnailAspectRatio="16:9"
            thumbnailUrl={lessonThumbnail}
          />
        </MediaPlayableInModal>
      }
    />
  )
}

export default WrapupCardLiveLesson
